import './AddRemoveButton.scss';
import { Button } from 'react-bootstrap';

interface AddRemoveButtonProps {
  step: number;
  minValue: number;
  addFn: Function;
  removeFn: Function;
  currentValue: number;
}

function AddRemoveButton({ step = 1, minValue = 0, addFn, removeFn, currentValue = 0 }: AddRemoveButtonProps) {
  const handleAdd = () => {
    addFn(currentValue + step);
  };

  const handleRemove = () => {
    if (currentValue - step < minValue) {
      return;
    }
    removeFn(currentValue - step);
  };

  return (
    <div>
      <Button onClick={handleRemove} disabled={currentValue - step < minValue} variant={'outline-primary'} className={'add-remove-button'}>
        -
      </Button>
      <Button onClick={handleAdd} variant={'outline-primary'} className={'add-remove-button ml-2'}>
        +
      </Button>
    </div>
  );
}

export default AddRemoveButton;
